import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import CartasFinanza from "./cartas";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
} from "../../util/varios";
import moment from "moment";
import CatalogoCuentaBancaria from "../../catalogos/catalogoCuentasBancarias";

const TablaCuentas = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let anio = JSON.parse(sessionStorage.getItem("anioactu"));

  const accbtnctsbancarias = JSON.parse(
    sessionStorage.getItem("accbtnctsbancariasc")
  );
  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtId = useRef();
  const txtDescripcion = useRef();
  const txtNombre = useRef();
  const txtNCuenta = useRef();
  const txtSucursal = useRef();
  const txtPersona = useRef();
  const txtTelefono = useRef();
  const txtDireccion = useRef();
  const txtSaldoCon = useRef();
  const txtSaldoLib = useRef();
  const txtConcepto = useRef();

  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();

  const [operacion, setOperacion] = useState(1);
  const [bancos, setBancos] = useState();
  const [idBanco, setIdBanco] = useState();
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Cuentas Bancarias."
  );

  const [habilitado, setHabilitado] = useState(true);
  const [catalogoCuenta, setCatalogoCuenta] = useState(false);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [titleCed, setTitleCed] = useState("Cédula:");
  const [cmbCedula, setCmbCedula] = useState([{ value: "V" }, { value: "E" }]);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });
  const [values, setValues] = useState({
    idcuentabancaria: "",
    nombre: "",
    cuentabancaria: "",
    sucursal: "",
    direccion: "",
    contacto: "",
    telefono: "",
    presupuesto: "",
    saldoconcil: "",
    saldolib: "",
    codctacont: "",
    tipo: "",
    concepto: "",
    debitobanc: "",
    porcentdebito: "",
    codctadebitobanc: "",
    idorganizacion: "",
    idefiscal: "",
    idbanco: "",
    caduca: "",
    idcuentacontable: "",
    depositoweb: "",
    activo: "",
  });

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false; //alert(e.which);
  };

  const [ciudades, setCiudades] = useState();
  const [totalCuentas, setTotalCuentas] = useState(0);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [operacionPer, setOperacionPer] = useState(0);

  const datosRes = () => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          if (response.data !== "") {
            setHabilitadoNU(true);
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtNomResp.current.value = response.data.nombres;
            txtApeResp.current.value = response.data.apellidos;
            txtDireccion.current.value = response.data.direccion;
            txtEmail.current.value = response.data.correoe;
            txtTlf1.current.value = response.data.tlf1;
            txtTlf2.current.value = response.data.tlf2;
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
          } else {
            txtNomResp.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "No existe una persona con este N° de cedula porfavor registre sus datos",
              icono: "informacion",
            });
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const idbancio = (id) => (e) => {
    e.preventDefault();
    setIdBanco(id);
  };
  const blanquear = () => {
    setTituloHeader("Gestionar Cuentas Bancarias.");

    setValues({
      idcuentabancaria: "",
      nombre: "",
      cuentabancaria: "",
      sucursal: "",
      direccion: "",
      contacto: "",
      telefono: "",
      presupuesto: "",
      saldoconcil: "",
      saldolib: "",
      codctacont: "",
      tipo: "",
      concepto: "",
      debitobanc: "",
      porcentdebito: "",
      codctadebitobanc: "",
      idorganizacion: "",
      idefiscal: "",
      idbanco: "",
      caduca: "",
      idcuentacontable: "",
      depositoweb: "",
      activo: "",
    });
    txtId.current.value = "";
    txtDireccion.current.value = "";
    setVisibleBtn("visible");

    setActivate(false);

    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 1;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/banco/actualizarcuentabancaria`;

    let body;

    body = {
      operacion: ope,
      nid:
        values.idcuentabancaria !== "" ? parseInt(values.idcuentabancaria) : 0,
      nombanc: values.nombre.toUpperCase().trim(),
      nrocuent: values.cuentabancaria.trim(),
      sucur: values.sucursal.toUpperCase().trim(),
      dir: values.direccion.toUpperCase().trim(),
      cont: values.contacto.toUpperCase().trim(),
      telf: values.telefono.trim(),
      presu: 0,
      salconc:
        txtSaldoCon.current.value !== ""
          ? parseFloat(
            txtSaldoCon.current.value.replace(/\./g, "").replace(",", ".")
          )
          : "0.00",
      sallib:
        txtSaldoLib.current.value !== ""
          ? parseFloat(
            txtSaldoLib.current.value.replace(/\./g, "").replace(",", ".")
          )
          : "0.00",
      ctacont: null,
      tip: null,
      concep: values.concepto.toUpperCase().trim(),
      impdeb: false,
      porc: 0,
      ctacontdeb: null,
      org: operacion === 1 ? 1 : values.idorganizacion.trim(),
      efis: values.idefiscal !== "" ? values.idefiscal : 1,
      idban: parseInt(idBanco),
      cadu: values.caduca === "" ? 60 : parseInt(values.caduca),
      idcta: null,
      depweb: true,
      idctanota: null,
      idctatransfe: null,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          txtNCuenta.current.value = "";
          txtSucursal.current.value = "";
          txtPersona.current.value = "";
          txtTelefono.current.value = "";
          txtSaldoCon.current.value = "";
          txtSaldoLib.current.value = "";
          txtConcepto.current.value = "";
          blanquear();

          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "ubicacion_key"'
          ) {
            mensaje = "Ya existe un Registro";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const onChange = (e) => {
    if (
      e.target.name === "direccion" ||
      e.target.name === "sucursal" ||
      e.target.name === "contacto" ||
      e.target.name === "concepto"
    ) {
      // e.target.value = e.target.value;
      setValues({ ...values, [e.target.name]: e.target.value });
    } else {
      setValues({ ...values, [e.target.name]: e.target.value });
    }
  };

  const seleccionarRegistro = () => {
    let campos = "*";
    let nomtab = "cuentabancaria";
    let nomid = "idcuentabancaria";
    let id = txtId.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            setValues(response.data);
            txtDireccion.current.value = response.data.direccion.trim();

            /*        if(response.data) */
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una marca con este codigo",
              icono: "informacion",
            });
            txtDescripcion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistro();
      } else {
        txtDireccion.current.value = "";
        setValues({
          idcuentabancaria: "",
          nombre: "",
          cuentabancaria: "",
          sucursal: "",
          direccion: "",
          contacto: "",
          telefono: "",
          presupuesto: "",
          saldoconcil: "",
          saldolib: "",
          codctacont: "",
          tipo: "",
          concepto: "",
          debitobanc: "",
          porcentdebito: "",
          codctadebitobanc: "",
          idorganizacion: "",
          idefiscal: "",
          idbanco: "",
          caduca: "",
          idcuentacontable: "",
          depositoweb: "",
          activo: "",
        });
        txtId.current.value = "";
      }
    }
  };

  const onChangeValidar = () => {
    let sigue = true;

    if (!botones.incluir || !botones.modificar) {
      if (
        txtNombre.current.value === "" ||
        txtNCuenta.current.value === "" ||
        txtSucursal.current.value === "" ||
        txtPersona.current.value === "" ||
        txtTelefono.current.value === "" ||
        txtDireccion.current.value === "" ||
        txtSaldoCon.current.value === "" ||
        txtSaldoLib.current.value === "" ||
        txtConcepto.current.value === ""
      ) {
        let mensaje = "";

        {
          txtNombre.current.value === ""
            ? (mensaje = "el Nombre")
            : txtNCuenta.current.value === ""
              ? (mensaje = "la Cuenta")
              : txtSucursal.current.value === ""
                ? (mensaje = "la Sucursal")
                : txtPersona.current.value === ""
                  ? (mensaje = "la Persona de Contacto")
                  : txtTelefono.current.value === ""
                    ? (mensaje = "el Telefono")
                    : txtDireccion.current.value === ""
                      ? (mensaje = "la Dirección")
                      : txtSaldoCon.current.value === ""
                        ? (mensaje = "el Saldo Conciliado")
                        : txtSaldoLib.current.value === ""
                          ? (mensaje = "Saldo en Libros")
                          : txtConcepto.current.value === ""
                            ? (mensaje = "Concepto")
                            : "";
        }

        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Ingresar Correctamente " + mensaje + ".",
          icono: "informacion",
        });

        {
          txtNombre.current.value === ""
            ? txtNombre.current.focus()
            : txtNCuenta.current.value === ""
              ? txtNCuenta.current.focus()
              : txtSucursal.current.value === ""
                ? txtSucursal.current.focus()
                : txtPersona.current.value === ""
                  ? txtPersona.current.focus()
                  : txtTelefono.current.value === ""
                    ? txtTelefono.current.focus()
                    : txtDireccion.current.value === ""
                      ? txtDireccion.current.focus()
                      : txtSaldoCon.current.value === ""
                        ? txtSaldoCon.current.focus()
                        : txtSaldoLib.current.value === ""
                          ? txtSaldoLib.current.focus()
                          : txtConcepto.current.value === ""
                            ? txtConcepto.current.focus()
                            : btnAcepta.current.focus();
        }

        sigue = false;
      }
    }
    if (sigue) {
      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "bancos";
    let orden = "idbanco";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setBancos(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarCuentas = () => {
    let campos = "idcuentabancaria";
    let nomtab = "cuentabancaria";
    let orden = "idcuentabancaria";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setTotalCuentas(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onCatalogoCuenta = (values) => {
    setCatalogoCuenta(false);

    setValues({
      idcuentabancaria: "",
      nombre: "",
      cuentabancaria: "",
      sucursal: "",
      direccion: "",
      contacto: "",
      telefono: "",
      presupuesto: "",
      saldoconcil: "",
      saldolib: "",
      codctacont: "",
      tipo: "",
      concepto: "",
      debitobanc: "",
      porcentdebito: "",
      codctadebitobanc: "",
      idorganizacion: "",
      idefiscal: "",
      idbanco: "",
      caduca: "",
      idcuentacontable: "",
      depositoweb: "",
      activo: "",
    });
    txtId.current.value = "";
    setValues(values);
    txtDireccion.current.value = values.direccion;
    txtId.current.value = values.idcuentabancaria;
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (
        accbtnctsbancarias &&
        accbtnctsbancarias.toString().substring(0, 1) === "1"
      ) {
        setVisibleBtn("hidden");
        setTituloHeader("Incluir Cuentas Bancarias.");
        setHabilitado(false);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (
        accbtnctsbancarias &&
        accbtnctsbancarias.toString().substring(1, 2) === "1"
      ) {
        setTituloHeader("Editar Cuentas Bancarias.");
        setVisibleBtn("hidden");
        setHabilitado(false);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (
        accbtnctsbancarias &&
        accbtnctsbancarias.toString().substring(3, 4) === "1"
      ) {
        setTituloHeader("Eliminar Cuentas Bancarias.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          aceptar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (
        accbtnctsbancarias &&
        accbtnctsbancarias.toString().substring(2, 3) === "1"
      ) {
        setTituloHeader("Consultar Cuentas Bancarias.");
        setVisibleBtn("hidden");
        setHabilitado(true);
        txtId.current.focus();
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          aceptar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        txtId.current.removeAttribute("disabled");
        txtId.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn("visible");
      blanquear();
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarCuentas();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12 py-5" style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-8 py-3 mx-auto card shadow ">
            <div className="col-md-12 row mx-auto  rounded py-2">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 azulGradiant shadow text-light justify-content-between">
                <div className="col-md-6">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <a href="/inicio" className="text-light ">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>
              <div
                className="row mx-auto border-azul py-3 rounded"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <div className="input-group input-group-sm mb-2 col-md-4 col-lg-3 col-xl-3 col-sm-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CODIGO:
                  </label>

                  <input
                    type="text"
                    name="idcuentabancaria"
                    className="form-control bg-light fs-6"
                    disabled
                    ref={txtId}
                    defaultValue={
                      values.idcuentabancaria !== null ||
                        values.idcuentabancaria !== ""
                        ? values.idcuentabancaria.trim()
                        : ""
                    }
                    onKeyUp={validarCuenta}
                    onBlur={validarCuenta}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                  <button
                    type="button"
                    disabled={botones.catalogo}
                    onClick={() => {
                      setCatalogoCuenta(true);
                    }}
                    className="btn btn-success"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                <div className="col-md-10"></div>

                <div className="input-group input-group-sm mb-2 col-xl-5 col-lg-6 col-md-12 col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    NOMBRE DEL BANCO:
                  </label>
                  <select
                    disabled={habilitado}
                    ref={txtNombre}
                    className="form-select form-select-sm text-uppercase"
                    name="nombre"
                    id="inputStatus"
                    onChange={onChange}
                    value={values && values.nombre.trim()}
                  >
                    <option value="">Seleccione</option>
                    {bancos &&
                      bancos.map((item, index) => (
                        <option
                          key={index}
                          value={item.nombre.trim()}
                          onClick={idbancio(item.idbanco)}
                        >
                          {" "}
                          {item.nombre}{" "}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="input-group input-group-sm mb-2 col-xl-4 col-lg-6 col-md-12 col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    N° DE CUENTA:
                  </label>
                  <input
                    type="text"
                    name="cuentabancaria"
                    className="form-control bg-light fs-6"
                    ref={txtNCuenta}
                    value={
                      values.cuentabancaria !== null ||
                        values.cuentabancaria !== ""
                        ? values.cuentabancaria.trim()
                        : ""
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-4 col-md-12 col-sm-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    SUCURSAL:
                  </label>
                  <input
                    type="text"
                    name="sucursal"
                    ref={txtSucursal}
                    className="form-control bg-light text-uppercase fs-6"
                    value={
                      values.sucursal !== null || values.sucursal !== ""
                        ? values.sucursal
                        : ""
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-2 col-xl-9  col-lg-8">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    PERSONA DE CONTACTO:
                  </label>
                  <input
                    type="text"
                    name="contacto"
                    className="form-control bg-light text-uppercase fs-6"
                    ref={txtPersona}
                    value={
                      values.contacto !== null || values.contacto !== ""
                        ? values.contacto
                        : ""
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-2 col-xl-3 col-lg-5 col-md-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TELEFONO:
                  </label>
                  <input
                    type="text"
                    name="telefono"
                    className="form-control bg-light fs-6"
                    maxLength={11}
                    ref={txtTelefono}
                    value={
                      values.telefono !== null || values.telefono !== ""
                        ? values.telefono.trim()
                        : ""
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                    onKeyUp={handleInputNumChange}
                    onBlur={handleInputNumChange}
                  />
                </div>

                <div className="input-group input-group-sm col-md-12  mb-2">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    DIRECCION:
                  </label>
                  <textarea
                    type="area"
                    className="form-control rounded bg-light text-uppercase fs-6"
                    style={{ height: 40 }}
                    ref={txtDireccion}
                    disabled={habilitado}
                    value={
                      values.direccion !== null || values.direccion !== ""
                        ? values.direccion
                        : ""
                    }
                    aria-label="With textarea"
                    name="direccion"
                    onChange={onChange}
                  ></textarea>
                </div>

                <div className="input-group input-group-sm mb-2 col-12">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    CONCEPTO:
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light text-uppercase fs-6"
                    name="concepto"
                    ref={txtConcepto}
                    value={
                      values.concepto !== null || values.concepto !== ""
                        ? values.concepto
                        : ""
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-2 col-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    SALDO CONCILIADO:
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light text-right fs-6"
                    name="saldoconcil"
                    ref={txtSaldoCon}
                    value={
                      values.saldoconcil !== null || values.saldoconcil !== ""
                        ? formatMoneda(
                          values.saldoconcil
                            .replace(",", "")
                            .replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                        : "0,00"
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                  />
                </div>

                <div className="input-group input-group-sm mb-2 col-4">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    SALDO EN LIBRO:
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light text-right fs-6"
                    name="saldolib"
                    ref={txtSaldoLib}
                    value={
                      values.saldolib !== null || values.saldolib !== ""
                        ? formatMoneda(
                          values.saldolib.replace(",", "").replace(".", ","),
                          ",",
                          ".",
                          2
                        )
                        : "0,00"
                    }
                    disabled={habilitado}
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onChange={onChange}
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                  />
                </div>
              </div>

              <div className="col-md-12 d-flex justify-content-between mt-3">

                {visibleBtn === "visible" ? <div
                  className="col-pd-600 d-flex justify-content-start"
                >
                  <button
                    disabled={botones.incluir}
                    onClick={onBotones(1)}
                    className="btn btn-sm mx-1 btn-primary rounded-pill"
                    title="Incluir Cuenta Bancaria"
                  >
                    <i className="fas fa-plus">
                      {" "}
                      Incluir{" "}
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.consultar}
                    onClick={onBotones(4)}
                    className="btn btn-sm mx-1 btn-info rounded-pill"
                    title="Consultar Cuenta Bancaria"
                  >
                    <i className="fas fa-eye">
                      Consultar
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.modificar}
                    onClick={onBotones(2)}
                    className="btn btn-sm mx-1 btn-warning rounded-pill"
                    title="Modificar Cuenta Bancaria"
                  >
                    <i className="fa fa-edit">
                      Modificar
                    </i>{" "}
                  </button>
                  <button
                    disabled={botones.eliminar}
                    onClick={onBotones(3)}
                    className="btn btn-sm mx-1 btn-danger rounded-pill"
                    title="Eliminar Cuenta Bancaria"
                  >
                    <i className="fa fa-trash">
                      Eliminar
                    </i>{" "}
                  </button>
                </div> : <div
                  className="col-pd-340 d-flex justify-content-end ml-auto"
                >
                  <button
                    ref={btnAcepta}
                    disabled={botones.aceptar}
                    onClick={onBotones(5)}
                    className="mx-2 btn btn-sm rounded-pill btn-success"
                  >
                    <i
                      className="fas fa-check-circle"
                    >
                      {" "}
                      Aceptar
                    </i>
                  </button>
                  <button
                    ref={btnCancela}
                    disabled={botones.cancelar}
                    onClick={onBotones(6)}
                    className="mx-2 btn btn-danger btn-sm rounded-pill"
                  >
                    <i
                      className="fas fa-window-close"
                    >
                      {" "}
                      Cancelar
                    </i>
                  </button>
                </div>}

              </div>
            </div>
          </div>
        </div>
      </div>
      <CatalogoCuentaBancaria
        show={catalogoCuenta}
        onHideCancelar={() => {
          setCatalogoCuenta(false);
        }}
        onHideAceptaCatalogo={onCatalogoCuenta}
      />

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaCuentas;



// WEBPACK FOOTER //
// ./src/components/finanzas/tablaCuentasBancarias.js